<template>
    <div>
        <sui-segment :loading="isLoading">
            <div class="inline-title">
                <sui-button icon="angle left" @click="onBackTo"></sui-button>
                <h1 is="sui-header">{{ $t('gateway.templates.configTitle') }}: {{ $route.query.templateName }}</h1>
            </div>
            <sui-form v-if="!isLoading">
                <sui-form-field>
                    <label>{{ $t('common.name') }}</label>
                    <sui-form-field>
                        <input
                            type="text"
                            v-model="configuration.name"
                        />
                    </sui-form-field>
                </sui-form-field>
            </sui-form>
            <div class="editor-container">
                <MonacoEditor
                    width="100%"
                    height="60vh"
                    theme="vs-dark"
                    v-model="configuration.css_content"
                    language="css"
                ></MonacoEditor>
            </div>
            <sui-button fluid
                        type="submit"
                        color="violet"
                        :content="isEdit ? $t('common.save') : $t('common.create')"
                        :disabled="!isValidForm"
                        @click="onSubmit"/>
        </sui-segment>
    </div>
</template>

<script>
import store from '@/store';
import MonacoEditor from 'monaco-editor-vue';
import * as CSSJSON from 'dntly-cssjson'
import { api } from '@/api';

export default {
    name: 'CustomerTemplateConfiguration',
    components: {
        MonacoEditor,
    },
    beforeDestroy() {
        store.commit('removeAppTitle');
    },
    data() {
        return {
            isLoading: false,
            configuration: {
                id: null,
                name: '',
                is_default: false,
                css_content: ''
            }
        }
    },
    computed: {
        isValidForm: {
            get() {
                return this.configuration.name
                    && this.isValidJSON();
            }
        },
        isEdit: {
            get() {
                return !!this.$route.params.configuration_id;
            }
        },
        state: {
            get() {
                return store.state;
            },
        }
    },
    async created() {
        this.setInitContext();
        store.commit('setAppTitle', `${this.$t('gateway.templates.configTitle')} - ${this.$route.query.templateName}`);
    },
    methods: {
        setInitContext() {
            if (this.isEdit) {
                this.getConfiguration();
            }
        },
        async getConfiguration() {
            this.isLoading = true;
            try {
                const data = await api.templates.getConfig(this.$route.params.template_id, this.$route.params.configuration_id);
                this.configuration = {...data, css_content: CSSJSON.jsonToCss(data.css_content)};
            } catch (err) {
                this.$toastr.e(err, this.$t('gateway.templates.errorLoading'));
                this.$router.go(-1);
            } finally {
                this.isLoading = false;
            }
        },
        async onSubmit() {
            this.isLoading = true;
            const data = {...this.configuration, css_content: CSSJSON.cssToJson(this.configuration.css_content)};
            try {
                await api.templates.saveConfig(this.$route.params.template_id, data);
                this.$toastr.s(this.isEdit ? this.$t('gateway.templates.configUpdated') : this.$t('gateway.templates.configCreated'))
                this.$router.push({name: 'CustomerTemplatesList'});
            } catch (err) {
                this.$toastr.e(
                    err.message,
                    this.isEdit
                        ? this.$t('gateway.templates.configUpdatedError')
                        : this.$t('gateway.templates.configCreatedError'),
                );
            } finally {
                this.isLoading = false;
            }
        },
        onBackTo() {
            this.$router.go(-1);
        },
        isValidJSON() {
            const json = CSSJSON.cssToJson(this.configuration.css_content);
            return json && JSON.stringify(json) !== '{}';
        },
    },
}
</script>

<style>
.inline-title {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
}

.inline-title .button {
    margin-right: 1rem;
}

.inline-title .ui.header {
    margin: 0;
}

.editor-container {
    margin: 2rem auto;
}
</style>
